import './App.css';
// import FileManager from './components/file1';
import FileManager from './components/file';

function App() {
    return (
        <div className="App">
            <FileManager />
        </div>
    );
}

export default App;
